var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlModal',{attrs:{"open-modal":_vm.showModal,"data-testid":"capacity-plan-saved-modal","config":_vm.config},on:{"close-modal":_vm.continueAction,"close":_vm.continueAction}},[_c('Localization',{attrs:{"message":_vm.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }